export default __webpack_public_path__ + "static/media/kid-2.abcdf289.jpg";